import React from "react";
import PropTypes from "prop-types";
const CustomSpacer = ({ sectionHeight }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "tint-custom-spacer" }, /* @__PURE__ */ React.createElement("div", { className: "tint-custom-spacer__wrapper" }, /* @__PURE__ */ React.createElement("span", { className: "counter" }, `${sectionHeight}px`)));
};
export default CustomSpacer;
CustomSpacer.propTypes = {
  sectionHeight: PropTypes.string
};
